<template>
  <div class="thres">
    <!-- 头部 -->
    <div class="thretop">
      <div class="thretop_title fs32">{{ data.name }}</div>
      <div class="thretop_msg fs22" :class="
          data.value >= data.lowerLimit && data.value <= data.uperLimit
            ? 'lv'
            : 'ho'
        ">
        {{ $t("live.waring_text") }}：{{ data.lowerLimit }}-{{ data.uperLimit
        }}{{ data.unit }}

        <span v-if="data && data.voltage" style="margin-left:20px">电压：{{ data.voltage }}v</span>
      </div>

      <div class="thretop_close" @click="handleCloseThres">
        <img src="src/assets/images/close.png" />
      </div>
    </div>
    <!-- body -->
    <div class="threform" v-if="type === 'cgq'">
      <div class="tform">
        <div class="txt fs28">{{ $t("live.thre_min") }}</div>
        <input type="number" v-model="lower" :placeholder="$t('live.thre_placsholder')" />
      </div>
      <div class="tform">
        <div class="txt fs28">{{ $t("live.thre_max") }}</div>
        <input type="number" v-model="uper" :placeholder="$t('live.thre_placsholder')" />
      </div>
      <div class="tis">{{ $t("live.msg_txt1") }}{{ $t("live.msg_txt2") }}</div>
    </div>
    <div class="threbtn fs28 orangeToYellow" @click="handleSetHold">
      {{ $t("live.thre_btn") }}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      type: "",
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "", // 记录的设备号
      uper: "",
      lower: "",
      showPopup: false,
      data: {},
      deviceType: null
    };
  },

  async created () {
    const data = JSON.parse(sessionStorage.getItem("liveSettingData"));
    const deviceType = sessionStorage.getItem('deviceType')
    console.log("data:", data.name);

    this.deviceType = deviceType
    this.type = this.$route.query.type;
    this.data = { ...data };

    this.getHold(data);

    deviceType == '20' && await this.getCgqList()
  },



  methods: {
    getCgqList () {
      this.$api.getLiveList20({ no: this.data.no }).then(res => {
        if (res.errcode === 0) {
          const { list } = res
          const find = list?.find(o => o.name === this.data.sensor)
          if (find) {
            this.data.ext = { ...find }
          }
        }
      })
    },

    // 读取传感器阈值
    getHold (data) {
      try {
        this.$toast.loading({
          message: this.$t("live.read_loading"),
          forbidClick: true,
          duration: 0
        });
        this.$api
          .getHold({
            channelNo: data.channelNo,
            no: this.no
          })
          .then(res => {
            console.log(res);
            if (res.errcode == 0) {
              if (this.$isblank(res.no)) {
                this.lowerLimit = "";
                this.uperLimit = "";
              } else {
                const {
                  channelName,
                  channelNo,
                  no,
                  lowerLimit,
                  uperLimit,
                  id
                } = res;
                const { index, unit, value, uuid, sensor } = data;
                const d = {
                  name: channelName,
                  channelNo,
                  no,
                  index,
                  lowerLimit,
                  uperLimit,
                  id,
                  unit,
                  value,
                  uuid,
                  sensor
                };

                this.data = { ...d };
                this.lower = lowerLimit;
                this.uper = uperLimit;
              }
            } else {
              this.$toast(res.errmsg);
            }
            this.$toast.clear();
          })
          .catch(err => {
            console.log(err);
            // 其他异常
            this.$toast.clear();
            this.$toast(this.$t("common.timeout"));
          });
      } catch (err) {
        console.error(err);
      }
    },

    // 设置阈值
    handleSetHold () {
      const { data, lower, uper } = this;
      if (this.$isblank(lower)) {
        this.$toast(this.$t("live.thre_min_msg"));
        return false;
      }
      if (this.$isblank(uper)) {
        this.$toast(this.$t("live.thre_max_msg"));
        return false;
      }
      var _this = this;
      this.$toast.loading({
        message: _this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });
      const { no, index, id, channelNo, uuid } = data;
      const param = {
        channelNo,
        no,
        lowerLimit: Number(lower),
        uperLimit: Number(uper),
        index,
        id,
        isNotify: false, // 是否通知
        notifyWay: "" // 1 微信，2 电话，3 邮箱
      };

      //设备类型 20 三代传感器
      if (this.deviceType == 20) {
        param.uuid = uuid
        param.sensorId = this.data?.ext?.id
      }

      console.log("进来了吗:", param, this.data);


      this.$api
        .setHold({ ...param })
        .then(res => {
          _this.$toast.clear();
          if (res.errcode === 0) {
            _this.$toast.success(_this.$t("first.thre_edit_success"));
            _this.handleCloseThres();
          } else {
            _this.$toast(res.errmsg);
          }
        })
        .catch(err => {
          console.log(err);
          // 其他异常
          _this.$toast.clear();
          _this.$toast(this.$t("common.timeout"));
        });
    },

    // 关闭
    handleCloseThres () {
      this.uperLimit = "";
      this.lowerLimit = "";
      this.showPopup = false;
    }
  }
};
</script>

<style lang="scss" scoped>
/*上滑层*/
.thretop {
  position: relative;
  border-bottom: 1px solid #f4f4f4;
  padding: 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(53, 105, 233, 0.9) 0%,
    rgba(24, 76, 204, 1) 100%
  ) !important;
  color: #ffffff;
}

.thretop .thretop_msg {
  color: #ffffff;
  padding-left: 0.3rem;
  background: url(../../../assets/images/lv.png) 0 0.15rem no-repeat;
  background-size: 0.22rem 0.22rem;
  padding-top: 0.1rem;
}

.thretop .thretop_msg.lv {
  background: url(../../../assets/images/lv.png) 0 0.15rem no-repeat;
  background-size: 0.22rem 0.22rem;
}

.thretop .thretop_msg.ho {
  background: url(../../../assets/images/red.png) 0 0.15rem no-repeat;
  background-size: 0.22rem 0.22rem;
}

.thretop .thretop_close {
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
}

.thretop .thretop_close img {
  width: 0.29rem;
  height: 0.29rem;
  vertical-align: text-top;
}

.threform {
  width: 6.7rem;
  margin: 0 auto;
  padding-top: 0.1rem;
}

.threform .tform {
  overflow: hidden;
  line-height: 1rem;
  background: #f4f4f4;
  border-radius: 0.1rem;
  margin-top: 0.2rem;
}

.threform .tform .txt {
  float: left;
  width: 2.06rem;
  text-align: center;
}

.threform .tform input {
  float: left;
  width: 4.64rem;
  border: none;
  background: none;
  font-size: 0.28rem;
  color: #285cdc;
}

.tis {
  font-size: 0.22rem;
  color: #999;
  text-align: center;
  padding: 0.25rem 0;
}

.threbtn {
  width: 6.7rem;
  margin: 0 auto;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.1rem;
  text-align: center;
  color: #fff;
  margin-top: 0.1rem;
}

/*上滑层 end*/
</style>
